module.exports = __webpack_public_path__ + "img/appImage-customer-base--1.9dc98f61.svg";